import { createTracker } from 'usage-tracker';
import events from 'SalesContentIndexUI/events.yaml';
import SearchContentTypes from '../data/constants/SearchContentTypes';
let usageTracker;
export const initTracker = () => {
  if (!usageTracker) {
    usageTracker = createTracker({
      events,
      properties: {
        namespace: 'SalesContentIndexUI'
      }
    });
  }
};
export const UsageTracker = {
  track: (eventName, eventProps) => {
    if (usageTracker) {
      usageTracker.track(eventName, eventProps);
    }
  }
};
export function trackModalIndexInteraction(contentType, action) {
  const event = {
    [SearchContentTypes.TEMPLATE]: 'salesModalTemplatesInteraction',
    [SearchContentTypes.DOCUMENT]: 'salesModalDocumentsInteraction',
    [SearchContentTypes.SEQUENCE]: 'salesModalSequencesInteraction'
  };
  if (event[contentType]) {
    UsageTracker.track(event[contentType], {
      action
    });
  }
}